/**
 * Back-to-top button, shown past a third of the page and latched against
 * infinite-scroll flicker. From 990px the scroller is .page-wrapper (html is
 * overflow:hidden), not the window.
 */
(function () {
  if (window.bqBackTopInit) return;
  window.bqBackTopInit = true;

  var bq = window.bq;
  if (!bq) return;

  var btn = document.querySelector('.bq-backtop');
  if (!btn) return;
  btn.hidden = false; // revealed only when the JS runs

  var squeeze = window.matchMedia('(min-width: 990px)');

  function container() {
    return (squeeze.matches && document.querySelector('.page-wrapper')) ||
      document.scrollingElement || document.documentElement;
  }
  function eventTarget() {
    return (squeeze.matches && document.querySelector('.page-wrapper')) || document;
  }

  // The footer's last rows sit under the two discs, so the discs park once
  // those rows are in view. The Nuwa launcher reads the same class.
  var footer = document.querySelector('.bq-footer') || document.querySelector('footer');
  var rangs = footer ? footer.querySelectorAll('.bq-footer__social, .bq-footer__bottom') : [];
  function parque() {
    var top = Infinity;
    for (var i = 0; i < rangs.length; i += 1) top = Math.min(top, rangs[i].getBoundingClientRect().top);
    if (top === Infinity && footer) top = footer.getBoundingClientRect().bottom - 120;
    document.documentElement.classList.toggle('bq-discs-parked', top < window.innerHeight - 8);
  }

  var ticking = false;
  var shown = false;
  function update() {
    ticking = false;
    var c = container();
    var max = c.scrollHeight - c.clientHeight;
    var y = c.scrollTop;
    if (!shown && max > 0 && y > max / 3) shown = true;
    else if (shown && y < c.clientHeight * 0.5) shown = false;
    btn.classList.toggle('is-visible', shown);
    parque();
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  var bound = null;
  function bind() {
    if (bound) bound.removeEventListener('scroll', onScroll);
    bound = eventTarget();
    bound.addEventListener('scroll', onScroll, { passive: true });
    update();
  }
  bind();
  // Rebind when crossing the 990px threshold (the scroll container changes).
  squeeze.addEventListener('change', bind);
  window.addEventListener('resize', onScroll, { passive: true });

  btn.addEventListener('click', function () {
    container().scrollTo({ top: 0, behavior: bq.reducedMotion() ? 'auto' : 'smooth' });
  });
})();
